import Axios from '@/api/http'

export function breakupfile (query) {
  return Axios({
    method: 'post',
    url: '/openapi/breakupfile',
    data: query,
    withCredentials: false
  })
}

export function aiextractfilemetadata (query) {
  return Axios({
    method: 'post',
    url: 'openapi/aiextractfilemetadata',
    data: query,
    withCredentials: false
  })
}

export function updateapprovingfilebyfeild (query) {
  return Axios({
    method: 'post',
    url: 'openapi/updateapprovingfilebyfeild',
    data: query,
    withCredentials: false
  })
}